import type { ReactNode } from 'react';

export const symbol_gondola_lift: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M192-120q-30 0-51-21t-21-51v-252q0-65 45.5-110.5T274-600h176v-129L76-627q-14 4-25-4.5T40-654q0-10 6-18t15-10l191-52q-4-6-5.5-12.5T245-760q0-21 15-35.5t36-14.5q20 0 35 14.5t15 35.5l104-28v-22q0-13 8.5-21.5T480-840q13 0 21.5 8.5T510-810v5l112-30q-4-6-6-12.5t-2-14.5q0-21 15-36t36-15q20 0 35 15t15 37l169-46q14-4 25 5t11 23q0 10-5.5 18T899-851L510-745v145h177q64 0 108.5 45.5T840-444v252q0 30-21 51t-50 21H192Zm-12-60h600v-107H180v107Zm0-167h160v-193h-66q-38 0-66 28t-28 68v97Zm220 0h160v-193H400v193Zm220 0h160v-97q0-40-27.5-68T687-540h-67v193ZM180-180v-107 107Z"
		/>
	</svg>
);
